import { db } from 'firebase/fbConfig';
import config from 'config';

class StoreService {
  // static getTracks = async (type, filter) => {
  //   let entries = [];
  //   // The query
  //   let query = db.collection(config.db.songCollection);
  //   if (filter && type) {
  //     query = query.where(filter, '==', type);
  //   }
  //   const snapshot = await query.get();
  //   // Parse data into array like in firebase.js
  //   snapshot.forEach((doc) => {
  //     const docData = doc.data();
  //     const entry = { ...docData, id: doc.id };
  //     // _TODO: remove string manipulation when only the image name is saved in db (rather than the google cloud path)
  //     // Only keep image name
  //     const { imgsrc } = entry;
  //     const image = imgsrc && setImageUrl(imgsrc.split('/').pop());
  //     entries.push({ ...entry, imgsrc: image });
  //   });
  //   return entries;
  // };
  static getUsers = async (limit) => {
    let data = [];
    const snapshot = await db
      .collection(config.db.userCollection)
      .limit(limit)
      .get();
    snapshot.forEach((doc) => {
      data.push({ ...doc.data(), uid: doc.id });
    });
    return data;
  };

  static getUserData = async (uid) => {
    const snapshot = await db
      .collection(config.db.userCollection)
      .doc(uid)
      .get();
    const data = snapshot.data();
    return (
      data && {
        // add id to data fetched
        uid: snapshot.id,
        ...data,
      }
    );
  };

  static addUser = async (user) => {
    await db.collection(config.db.userCollection).doc(user.uid).set(user);
  };

  static updateUser = async (uid, keyValues) => {
    await db
      .collection(config.db.userCollection)
      .doc(uid)
      .set(keyValues, { merge: true });
  };

  static updateUserFavorites = async (uid, list) => {
    await StoreService.updateUser(uid, { favoriteSongs: list });
  };

  static updateUserActivity = async (uid, list) => {
    await StoreService.updateUser(uid, { recentActivity: list });
  };
}

export default StoreService;
